'use client';

import { c as _c } from "react/compiler-runtime";
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Box, ButtonBase, Snackbar, Typography } from '@mui/material';
import { useState } from 'react';
import { ALERT_POP_UP_ICON } from '../constants';
export const ErrorPopup = () => {
  const $ = _c(13);
  const [open, setOpen] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      vertical: "top",
      horizontal: "center"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      px: {
        xs: 2
      },
      pt: {
        xs: 3,
        md: 1
      }
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      bgcolor: "common.white",
      borderRadius: 1,
      boxShadow: "0px 1px 3px 0px #0000004D",
      pl: "20px",
      pr: 2,
      py: {
        xs: 2,
        sm: "12px"
      },
      borderLeft: "4px solid",
      borderColor: "reds.main"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Box sx={{
      display: "flex",
      alignSelf: "flex-start"
    }}><CdnImage width={24} height={24} src={ALERT_POP_UP_ICON} alt="Error Alert" /></Box>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box sx={{
      display: "flex",
      whiteSpace: {
        xs: "wrap",
        sm: "nowrap"
      },
      pl: 2
    }}><Typography variant="textSmall">Something went wrong. Please refresh the page.</Typography></Box>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setOpen(false);
      window.location.reload();
    };
    t6 = {
      ml: 1,
      alignSelf: "center",
      px: "12px"
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ButtonBase onClick={t5} sx={t6}><Typography variant="textSmallBold" sx={{
        color: "reds.dark",
        lineHeight: 1.5
      }}>Refresh</Typography></ButtonBase>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpen(false);
    t9 = {
      px: 1
    };
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Box sx={t2}>{t3}{t4}{t7}<ButtonBase onClick={t8} sx={t9}><span aria-hidden="true" className="mask-icon mask-icon-close" style={{
          width: "20px",
          height: "20px",
          backgroundColor: "#64666A"
        }} /></ButtonBase></Box>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== open) {
    t11 = <Snackbar open={open} anchorOrigin={t0} autoHideDuration={null} sx={t1}>{t10}</Snackbar>;
    $[11] = open;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
};